/**
 * Landing Page - Refactored to use modular components
 * Original: 772 lines -> Refactored: ~80 lines
 */
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getCurrencies } from '../lib/api';

// Import landing page components
import {
  LandingHeader,
  LandingHero,
  LandingFeatures,
  LandingHowItWorks,
  LandingCTA,
  LandingFooter,
  CurrencyConverter,
  TransactionProtection,
  GlobalBusinessHub,
  GlobalFeatures,
  PricingSection,
  WhyParachPay
} from '../components/landing';

// External components
import ImageCarousel from '../components/ImageCarousel';
import InstallAppBanner from '../components/InstallAppBanner';

const Landing = () => {
  const { user } = useAuth();
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await getCurrencies();
        setCurrencies(res.data);
      } catch (error) {
        // Use fallback currencies if API fails
        setCurrencies([
          { code: 'USD', symbol: '$', rate: 1.0 },
          { code: 'EUR', symbol: '€', rate: 0.92 },
          { code: 'GBP', symbol: '£', rate: 0.79 },
          { code: 'JPY', symbol: '¥', rate: 149.50 },
          { code: 'CHF', symbol: 'Fr', rate: 0.88 },
          { code: 'CAD', symbol: 'C$', rate: 1.36 },
          { code: 'AUD', symbol: 'A$', rate: 1.53 },
          { code: 'INR', symbol: '₹', rate: 83.12 },
          { code: 'CNY', symbol: '¥', rate: 7.24 },
          { code: 'MXN', symbol: '$', rate: 17.15 }
        ]);
      }
    };
    fetchCurrencies();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* PWA Install Banner */}
      <InstallAppBanner />
      
      {/* Header */}
      <LandingHeader user={user} />

      {/* Hero Section */}
      <LandingHero user={user} />

      {/* Why ParachPay - Value Proposition */}
      <WhyParachPay />

      {/* Features Section */}
      <LandingFeatures />

      {/* Image Carousel - Premium Card Designs */}
      <ImageCarousel />

      {/* How It Works */}
      <LandingHowItWorks />

      {/* Currency Converter Calculator */}
      <CurrencyConverter currencies={currencies} />

      {/* Global Features Section - Image Left, Text Right */}
      <GlobalFeatures />

      {/* Fair & Transparent Pricing Section */}
      <PricingSection />

      {/* CTA Section */}
      <LandingCTA />

      {/* Transaction Protection Section */}
      <TransactionProtection />

      {/* Global Business Hub Section */}
      <GlobalBusinessHub />

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default Landing;
